import './float.css'

function BodiosYakDown() {
  return (
    <main className="w-full text-center uppercase text-[330px] text-stone-800 max-md:mt-10 max-md:max-w-full max-md:text-4xl ">
      <section className="image-container">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/5e35e722e45763f755039711ffc5e069c4303f77b1ab52ec9e4dd057ea493906?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1"
          alt="Descriptive"
          className="object-contain w-full"
          loading="lazy"
        />
      </section>
    </main>
  );
}

export default BodiosYakDown;